<template>
  <v-container id="parentDashboard" fluid>
    <v-row>
      <WelcomeBanner :userName="user.name" />
    </v-row>
    <v-row>
      <ChildrenSection class="section-cotainer" />
    </v-row>
  </v-container>
</template>

<script>
  import WelcomeBanner from "@/components/WelcomeBanner";
  import ChildrenSection from "@/components/ParentDashboard/ChildrenSection";

  export default {
    name: "ParentDashboard",
    components: { WelcomeBanner, ChildrenSection },
    computed: {
      user() {
        return this.$store.getters.userInfo;
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/ParentDashboard/ParentDashboard.vue